import { IconProps } from '@tamagui/helpers-icon';
import { Card } from '@unistocks/components/layout/card';
import { Heading, Paragraph } from '@unistocks/components/text/text';
import { Href, Link } from 'expo-router';
import { ComponentType } from 'react';

export type DashboardCardProps = {
  href: Href;
  Icon: ComponentType<IconProps>;
  title: string;
  description: string;
};

export const DashboardCard: React.FC<DashboardCardProps> = ({ href, Icon, title, description }) => {
  return (
    <Link href={href} asChild>
      <Card
        pressable
        hoverable
        bordered
        transition={'quickerLessBouncy'}
        elevation={'$true'}
        p={'$4'}
        w="100%"
        $md={{ maxW: 200 }}
        hoverStyle={{
          y: -10,
          scale: 1.05
        }}
      >
        <Card.Header>
          <Icon size={'$3'} color={'$unistocks'} />
        </Card.Header>
        <Heading size={'$6'}>{title}</Heading>
        <Paragraph size={'$3'} color={'$gray10'}>
          {description}
        </Paragraph>
      </Card>
    </Link>
  );
};
